module.exports = __webpack_public_path__ + "img/logo-placeholder.6fb9ff5.svg";